import { AttributesValueType } from '@iota/iota-management-portal-v4-client';

export const AttributeValueTypes = [
    AttributesValueType.BOOL,
    AttributesValueType.DATE,
    AttributesValueType.DATETIME,
    AttributesValueType.INTEGER,
    AttributesValueType.NUMBER,
    AttributesValueType.STRING,
    AttributesValueType.UUID
];

export const AttributeValueTypeDescriptions = new Map([
    ['INTEGER', $localize`integer`],
    ['NUMBER', $localize`floating-point number`],
    ['STRING', $localize`Text`],
    ['BOOL', $localize`truth-value`],
    ['DATE', $localize`Date (without time)`],
    ['DATETIME', $localize`Date (with time)`],
    ['UUID', $localize`ID`]
]);
